@if (districts && districts.length && kvDistricts) {
  <div class="mb-2 flex gap-3 align-items-center">
    @if (label) {
      <label class="flex gap-2 align-items-center"
        ><i class="fas fa-map-location-dot"></i> {{ label }}</label
      >
    }

    @if (getKeys().length > 10) {
      <app-search-input (search)="setDistricts($event)"></app-search-input>
    }
    <app-check-all
      class="ml-auto"
      [(selection)]="selection"
      [items]="getKeys()"
      (selectionChange)="onChange($event)"></app-check-all>
  </div>

  <div class="flex flex-column flex-wrap gap-1 h-10rem">
    @for (district of districts; track district.key) {
      <p-checkbox
        [label]="district.name"
        [name]="name"
        [value]="district.key + ''"
        [binary]="true"
        [ngModel]="isInverseSelected(district.key)"
        (ngModelChange)="toggleSelection(district.key, $event)" />
    }
  </div>
}
